import React from "react";
import { Box, Button, Typography, Grid, Divider, Stack } from "@mui/material";
import Modal from "components/shared/Modal";
import { Image } from "semantic-ui-react";

const MultiAgentModal = ({ open, onNo, onYes, coverages = [], clientName, logoUrl }) => {
  return (
    <Modal
      open={open}
      title="Do you use different agents/brokers for each type of insurance coverage below?"
      maxWidth="sm"
      content={
        <Grid container spacing={2}>
          {/* Left side - Coverage information */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Required Insurance Coverages:
            </Typography>
            {coverages.map((coverage, index) => (
              <Typography key={index} variant="body1" paragraph>
                {index + 1}. {coverage.label || coverage}
              </Typography>
            ))}
          </Grid>
          
          {/* Vertical divider */}
          <Grid item xs={12} md={0.5} sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Divider orientation="vertical" flexItem />
          </Grid>
          
          {/* Horizontal divider for mobile */}
          <Grid item xs={12} sx={{ display: { xs: 'block', md: 'none' } }}>
            <Divider flexItem sx={{ my: 2 }} />
          </Grid>
          
          {/* Right side - Client information */}
          <Grid item xs={12} md={5.5} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            {clientName && (
              <Box sx={{ mb: 2, textAlign: 'center' }}>
                <Typography 
                  variant="body2" 
                  color="text.secondary"
                  sx={{ mb: 0.5 }}
                >
                  Requested By:
                </Typography>
                <Typography 
                  variant="h6" 
                  fontWeight="medium"
                >
                  {clientName}
                </Typography>
              </Box>
            )}
            {logoUrl && (
              <Box sx={{ maxWidth: '100%', textAlign: 'center' }}>
                <Image src={logoUrl} alt={clientName} style={{ maxHeight: '120px', width: 'auto' }} />
              </Box>
            )}
          </Grid>
        </Grid>
      }
      actions={
        <>
          <Button onClick={onNo} color="primary" variant="outlined">
            No
          </Button>
          <Button onClick={onYes} color="primary" variant="contained">
            Yes
          </Button>
        </>
      }
    />
  );
};

export default MultiAgentModal;
